import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Fade } from "@material-ui/core";
import axios from "axios";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import NotaFiscalIcon from "../../../../../assets/img/icon-nota-fiscal.svg";
import { useGerarRelatorioRMNRB2 } from "../../../../../data/api/gestao/relatorios/gerar-relatorio-rmnrb2";
import { KeyValueModel } from "../../../../../model";
import { useToastSaurus } from "../../../../../services/app";
import { useEmpresaAtualHandler } from "../../../../../services/app/use-cases/empresa-atual-handler";
import { PageHeader } from "../../../../components/headers/header-page/header-page";
import { CircularLoading } from "../../../../components/utils/circular-loading";
import { EMeses, EMesesMap, RelatorioMensalReceitaB2Model } from "../models/relatorio-models";
import { RelatorioRelacaoMensalReceitaB2Form } from "./relatorio-relacao-mensal-receita-b2-form";
import { relatorioDisplay, useStyles } from "./relatorio-relacao-mensal-receita-b2-styles";

export const RelatorioRelacaoMensalReceitaB2 = () => {
    const [formRMNRB2, setFormRMNRB2] = useState({ ano: new Date().getFullYear() } as RelatorioMensalReceitaB2Model);
    const [relatorioRMNRB2Gerado, setRelatorioRMNRB2Gerado] = useState("");
    const styles = useStyles();

    const [errorValidationfarmaceutico, setErrorValidationfarmaceutico] = useState(false);

    const { gerarRelatorioRMNRB2, carregando } = useGerarRelatorioRMNRB2();
    const { getEmpresaAtualEndereco } = useEmpresaAtualHandler();
    const { showToast } = useToastSaurus();

    const listaMeses = Object.values(EMeses)
        .filter(e => !isNaN(Number(e))).map(i => i as EMeses)
        .map((mes: EMeses) => new KeyValueModel(mes, EMesesMap.get(mes)));

    const schema = yup
        .object()
        .shape({
            farmaceutico: yup.string().required("O Farmacêutico é obrigatório!"),
            mes: yup.number().required("O Mês é obrigatório!"),
            ano: yup.number().required("O Ano é obrigatório!"),
        });

    const { register, formState, setError } = useForm<RelatorioMensalReceitaB2Model>({
        criteriaMode: 'all',
        mode: 'onSubmit' && 'onTouched',
        resolver: yupResolver(schema)
    });

    const handleEmpresaEndereco = useCallback(async (form: RelatorioMensalReceitaB2Model) => {
        let enderecoEmpresa = await getEmpresaAtualEndereco();

        if (enderecoEmpresa === undefined)
            return;

        setFormRMNRB2({ ...form, enderecoEmpresa });
    }, [getEmpresaAtualEndereco]);

    useEffect(() => {
        if (
            formRMNRB2 === undefined ||
            formRMNRB2?.enderecoEmpresa !== undefined ||
            getEmpresaAtualEndereco === undefined
        ) return;

        handleEmpresaEndereco(formRMNRB2);
    }, [formRMNRB2, getEmpresaAtualEndereco, handleEmpresaEndereco]);

    useEffect(() => {
        if (relatorioRMNRB2Gerado.length)
            baixarRelatorio();
    }, [relatorioRMNRB2Gerado]);

    const gerarRelatorio = async () => {
        validarCampos();

        if (!await schema.isValid(formRMNRB2))
            return showToast("error", "Campos obrigatórios não preenchidos!", 5000, 'top-center');

        try {
            let res = await gerarRelatorioRMNRB2(formRMNRB2);

            if (res.erro)
                throw res.erro;

            if (!res.resultado?.data)
                return;

            setRelatorioRMNRB2Gerado(res.resultado?.data);
        } catch (e: any) {
            if (axios.isCancel(e))
                return;

            showToast('error', e.message);
        }
    };

    const validarCampos = async () => {
        setErrorValidationfarmaceutico(true);

        try {
            await schema.validate({
                mes: formRMNRB2.mes,
                ano: formRMNRB2.ano
            }, { abortEarly: false });
        } catch (error) {

            const validationError = error as yup.ValidationError;

            validationError?.inner?.forEach(err => {
                const path = err.path?.toString();

                if (path && Object.prototype.hasOwnProperty.call(schema.fields, path))
                    setErrorField(path, err.message);

            });

            return false;
        }
    }

    function setErrorField(path: string, errorMensage: string) {

        switch (path) {

            case 'mes':
                setError('mes', {
                    type: 'manual',
                    message: errorMensage,
                });
                break;

            case 'ano':
                setError('ano', {
                    type: 'manual',
                    message: errorMensage,
                });
                break;

            default:
                break;
        }

    }

    const baixarRelatorio = () => {
        let link = document.getElementById('relatorioLink');
        link?.click();
    };

    return (
        <>
            <Fade in mountOnEnter unmountOnExit>
                <div className={`flex-column w-100 h-100 ${styles.defaultContainer}`}>
                    <PageHeader showBotaoVoltar titulo='RMNRB2 - Relação Mensal de Receitas B2' />

                    <div className={`flex-column w-100 ${styles.formPadding}`}>

                        <div className={`flex-column ${styles.formContainer}`}>
                            <div className={`flex-column w-100 h-100`}>
                                <RelatorioRelacaoMensalReceitaB2Form
                                    listaMeses={listaMeses}
                                    formState={formState}
                                    register={register}
                                    formRMNRB2={formRMNRB2}
                                    setFormRMNRB2={setFormRMNRB2}
                                    errorValidationfarmaceutico={errorValidationfarmaceutico}
                                    setErrorValidationfarmaceutico={res => setErrorValidationfarmaceutico(res)}
                                />
                            </div>
                        </div>

                        <a id="relatorioLink" href={relatorioRMNRB2Gerado} target="_blank" style={relatorioDisplay} />
                        <div className={`flex-row w-100 ${styles.buttonContainer}`}>
                            <div className={classNames(styles.buttonStyle, styles.darkButton)}>
                                <Button onClick={() => !carregando ? gerarRelatorio() : {}} variant="text" className="h-100 w-100">
                                    {carregando ? <CircularLoading tipo="FULLSIZED" /> :
                                        <>
                                            <img src={NotaFiscalIcon} alt="" style={{ marginRight: '2%' }} />
                                            <div className={`flex-row ${styles.buttonLabel} ${styles.whiteLabel}`}>
                                                Gerar Relatório
                                            </div>
                                        </>
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </>

    );
} 